module.exports = __webpack_public_path__ + "img/water-level-new1.93fe2766.png";